$(function () {
    // Sobrescreve o método number do jQuery Validate para aceitar vírgula
    $.validator.methods.number = function (value, element) {
        return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[.,]\d{3})+)(?:[.,]\d+)?$/.test(value);
    };
});

// 👇 Flag global para evitar blur durante submit
let formSending = false;

$(document).on('submit', 'form', function (e) {
    formSending = true; // 👈 ativa flag

    var form = $(this).closest('form')[0];

    if (!validarCamposTabs(form, e)) {
        formSending = false; // 👈 reseta se inválido
        return;
    }

    e.preventDefault();

    $(form).find('input, select, textarea').each(function () {
        this.setCustomValidity('');
    });

    $(form).find('input, select, textarea').prop('disabled', false).prop('readonly', false);
    $(this).prop('disabled', true);

    form.submit();
});

$(function () {
    $('.js-autodisable').each(function () {
        var field = $(this);
        var val = field.val();
        if (val !== "" && val !== "0" && val !== null) {
            field.prop("disabled", true).prop("readonly", true);
            if (field.hasClass('select2-hidden-accessible')) {
                field.trigger('change.select2');
            }
        }
    });

    $("input[type=number]").on('keyup', function () {
        var max = parseInt($(this).attr('max'));
        var min = parseInt($(this).attr('min'));
        if ($(this).val() > max) {
            $(this).val(max);
        }
        else if ($(this).val() < min) {
            $(this).val(min);
        }
    });
});

function validarCamposTabs(form, event) {

    let invalidInput = $(form)
        .find('input:invalid, select:invalid, textarea:invalid')
        .not('.js-maskMoney, .js-maskNumero')
        .first();

    if (!invalidInput.length) {
        let invalidSelect = $(form).find('select').filter(function () {
            return $(this).prop('required') && ($(this).val() === "");
        }).first();
        if (invalidSelect.length) {
            invalidInput = invalidSelect;
        }
    }

    if (invalidInput.length) {
        event.preventDefault();

        let $tabPane = invalidInput.closest('.tab-pane');
        let tabId = $tabPane.attr('id');

        if (tabId) {
            let tabTrigger = document.querySelector(`a[data-bs-toggle="tab"][href="#${tabId}"]`);
            if (tabTrigger) {
                let tab = new bootstrap.Tab(tabTrigger);
                tab.show();
            }
        }

        if (invalidInput.is('select') && (invalidInput.val() === "")) {
            invalidInput[0].setCustomValidity("Selecione uma opção válida.");
            invalidInput[0].reportValidity();
            setTimeout(() => invalidInput[0].setCustomValidity(""), 3000);
        } else {
            invalidInput[0].reportValidity();
        }

        invalidInput.focus();
        return false;
    }

    return true;
}

$(function () {
    // 👇 Blur com proteção da flag formSending
    $(document).on('blur', 'input', function () {
        if (formSending) return; // 👈 ignora blur durante submit

        const input = this;
        if (input.classList.contains('js-maskCPF')) {
            validaCPF(input);
        }
        if (input.classList.contains('js-maskCNPJ')) {
            validaCNPJ(input);
        }
        if (input.classList.contains('js-maskCPFCNPJ')) {
            validaCPFCNPJ(input);
        }
        if (input.classList.contains('js-maskFone')) {
            validaTelefone(input);
        }
        if (input.classList.contains('js-maskEmail')) {
            validaEmail(input);
        }
        if (input.classList.contains('js-maskData')) {
            validaData(input);
        }
        if (input.classList.contains('js-maskCEP')) {
            validaCEP(input);
        }
        if (input.classList.contains('js-maskMoney')) {
            validaValor(input);
        }
        if (input.classList.contains('js-maskNumero')) {
            validaNumero(input);
        }
    });

    // Validação ao carregar a página
    $('.js-maskCPF, .js-maskCNPJ, .js-maskCPFCNPJ, .js-maskFone, .js-maskEmail, .js-maskCEP, .js-maskData, .js-maskMoney, .js-maskNumero').each(function () {
        if (this.value !== "") {
            if (this.classList.contains('js-maskCPF')) validaCPF(this);
            if (this.classList.contains('js-maskCNPJ')) validaCNPJ(this);
            if (this.classList.contains('js-maskCPFCNPJ')) validaCPFCNPJ(this);
            if (this.classList.contains('js-maskFone')) validaTelefone(this);
            if (this.classList.contains('js-maskEmail')) validaEmail(this);
            if (this.classList.contains('js-maskCEP')) validaCEP(this);
            if (this.classList.contains('js-maskData')) validaData(this);
            if (this.classList.contains('js-maskMoney')) validaValor(this);
            if (this.classList.contains('js-maskNumero')) validaNumero(this);
        }
    });
});

function previewImage(input) {
    if (input.files && input.files[0]) {
        const container = input.closest('.logotipo-preview-wrapper');
        const imgPreview = container.querySelector('img');
        if (imgPreview) {
            const url = URL.createObjectURL(input.files[0]);
            imgPreview.src = url;
            imgPreview.onload = () => URL.revokeObjectURL(url);
        }
    }
}

function previewImageBase64(input) {
    if (input.files && input.files[0]) {
        const reader = new FileReader();
        const wrapper = input.closest('.logotipo-preview-wrapper');
        const imgPreview = wrapper.querySelector('img');
        const hiddenInput = wrapper.querySelector('input[name="ImgLogotipoBase64"]');

        reader.onload = function (e) {
            const base64 = e.target.result;
            if (imgPreview) {
                imgPreview.src = base64;
            }
            if (hiddenInput) {
                hiddenInput.value = base64;
            }
        };

        reader.readAsDataURL(input.files[0]);
    }
}

$(function () {
    aplicarDisableAutoComplete();
});

function aplicarDisableAutoComplete() {
    // Seletor de tipos de input que fazem sentido para autocomplete
    var seletorInputs = 'input[type="text"], input[type="password"], input[type="email"], input[type="tel"], input[type="search"], input[type="number"]';

    // 1. Formulários com a classe -> aplica em todos os inputs dele
    $('form.disableAutoComplete').each(function () {
        $(this).attr('autocomplete', 'off');
        $(this).find(seletorInputs).each(function () {
            aplicarTruqueNoCampo($(this));
        });
    });

    // 2. Inputs individuais com a classe (mesmo fora de um form.disableAutoComplete)
    $(seletorInputs + '.disableAutoComplete').each(function () {
        aplicarTruqueNoCampo($(this));
    });
}

function aplicarTruqueNoCampo($campo) {
    // Evita aplicar duas vezes no mesmo campo
    if ($campo.data('autocomplete-off-applied')) {
        return;
    }

    $campo.attr('autocomplete', 'new-password');
    $campo.prop('readonly', true);
    $campo.addClass('js-autocomplete-trick'); // usado no CSS pra não pegar o estilo de readonly comum
    $campo.data('autocomplete-off-applied', true);
}

// Libera o campo real quando o usuário foca
$(document).on('focus', '.js-autocomplete-trick', function () {
    $(this).prop('readonly', false);
});

// Reaplica o readonly ao sair do campo (reforça o bloqueio pro autofill)
$(document).on('blur', '.js-autocomplete-trick', function () {
    $(this).prop('readonly', true);
});